import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['checkbox', 'submit']

  connect() {
    this.toggleDisability();
  }

  toggleDisability() {
    if (this.hasCheckboxTarget) {
      this.submitTarget.disabled = !this.checkboxTarget.checked;
    } else {
      this.submitTarget.disabled = false
    }
  }
}
